import {
  ADD_MAIL_SERVICE,
  DELETE_MAIL_SERVICE,
  EDIT_MAIL_SERVICE,
  EDIT_STATUS_MAIL_SERVICE,
  MAIL_SERVICE,
  RESET,
} from '../../types';

import { MailService } from '@/api/api';

export const state = () => ({
  mails: [],
});

export const getters = {
  [MAIL_SERVICE]({ mails }) {
    return mails;
  },
};

/* eslint-disable no-param-reassign */
export const mutations = {
  [MAIL_SERVICE](stateObj, mails) {
    stateObj.mails = mails;
  },
  [EDIT_MAIL_SERVICE](stateObj, { id, ...newMailProperties }) {
    stateObj.mails = stateObj.mails.map(({ id: mailId, ...mailProperties }) => {
      if (mailId === id) {
        return {
          id,
          ...mailProperties,
          ...newMailProperties,
        };
      }
      return {
        id: mailId,
        ...mailProperties,
      };
    });
  },
  [ADD_MAIL_SERVICE](stateObj, mail) {
    stateObj.mails.unshift(mail);
  },
  [DELETE_MAIL_SERVICE](stateObj, mailIdToDelete) {
    stateObj.mails = stateObj.mails.filter(({ id }) => id !== mailIdToDelete);
  },
  [RESET](stateObj) {
    Object.assign(stateObj, state());
  },
};

export const actions = {
  [MAIL_SERVICE]({ commit }) {
    return MailService.getEmails().then(mails => {
      commit(MAIL_SERVICE, mails);
    });
  },
  [EDIT_MAIL_SERVICE]({ commit }, mail) {
    return MailService.editEmail(mail).then(message => {
      commit(EDIT_MAIL_SERVICE, mail);
      return message;
    });
  },
  [ADD_MAIL_SERVICE]({ commit }, newMail) {
    return MailService.addEmail(newMail).then(({ recipient, message }) => {
      commit(ADD_MAIL_SERVICE, recipient);
      return message;
    });
  },
  [EDIT_STATUS_MAIL_SERVICE]({ commit }, { id, active }) {
    return MailService.editEmailStatus({ id, active }).then(message => {
      commit(EDIT_MAIL_SERVICE, { id, active });
      return message;
    });
  },
  [DELETE_MAIL_SERVICE]({ commit }, id) {
    return MailService.deleteEmail(id).then(message => {
      commit(DELETE_MAIL_SERVICE, id);
      return message;
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
